import React from "react";
import { Button } from "antd";
import { router } from "umi";

const AddUserButton = ({ disabled, entityId }) => {
  const handleClick = () => {
    router.push(`/add-user?entityId=${entityId}`);
  };

  return (
    <Button type="primary" onClick={handleClick} disabled={disabled}>
      Add User
    </Button>
  );
};

export default AddUserButton;
